/**
 * ============================================
 * FordSync4 Content Gate — 安全版 (theme-agnostic)
 *
 * 用法(文章 HTML 编辑器里,点 <> 切到 HTML 模式):
 *   在想门控的位置插入标记:  <!-- customer-only -->
 *   或指定内容 slug:          <!-- customer-only: forscan-sync4 -->
 *
 * ⚠️ 重要:标记【之后】的正文【不要】放真实内容。
 *   真实内容存放在 Cloudflare D1 的 guides 表里(按 slug),
 *   验证订单后由 worker 下发——页面源码里没有,竞争对手抓不到。
 *   不指定 slug 时,默认用文章的 handle(URL 最后一段)当 slug。
 *
 * 上传到 Shopify Assets;snippet(fs4-community.liquid)会自动加载本文件。
 *
 * 本版修复:不再依赖任何文章容器 class(原版靠写死的 .rte /
 *   .article-template__content 等定位,换主题就失效);改为在整个文档里
 *   定位 <!-- customer-only --> 注释并就地插入锁框。并加 DOM 就绪保护,
 *   避免脚本在正文渲染前执行。
 * ============================================
 */
(function () {
  'use strict';

  // 指向我们这次建好的安全 worker(内容存 D1、验证后才下发)
  var API_BASE = 'https://fordsync4-gate.fs4.workers.dev';

  // 记住已验证的凭证(用户自己的订单号+姓名,低敏感),免每篇重填
  function getCreds() {
    try { return JSON.parse(localStorage.getItem('fs4_creds') || 'null'); } catch (e) { return null; }
  }
  function setCreds(c) {
    try { localStorage.setItem('fs4_creds', JSON.stringify(c)); } catch (e) {}
  }

  function init() {
    // 在整个文档里找 <!-- customer-only --> 注释标记(不依赖任何容器 class)
    var markerNode = null, markerSlug = '';
    var root = document.body || document.documentElement;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_COMMENT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      var t = (node.nodeValue || '').trim().toLowerCase();
      if (t === 'customer-only' || t.indexOf('customer-only') === 0) {
        markerNode = node;
        var parts = t.split(':');
        if (parts.length > 1) markerSlug = parts[1].trim();
        break;
      }
    }
    if (!markerNode) return; // 没有标记 → 整篇公开,不做任何处理

    var parent = markerNode.parentNode;
    if (!parent) return;

    // 兜底:清掉标记之后、同一父节点内可能遗留的正文(真实内容应在 D1)
    var sib = markerNode.nextSibling;
    while (sib) { var rm = sib; sib = sib.nextSibling; rm.parentNode.removeChild(rm); }

    // slug:标记里指定的优先,否则用文章 handle(URL 最后一段)
    var slug = markerSlug || (location.pathname.split('/').filter(Boolean).pop() || '');

    // 内容容器(由 worker 返回的 HTML 注入)
    var gated = document.createElement('div');
    gated.id = 'fs4-gated-content';
    gated.style.display = 'none';

    // 锁定提示框(沿用原 UI)
    var lockBox = document.createElement('div');
    lockBox.id = 'fs4-content-lock';

    var style = document.createElement('style');
    style.textContent =
      '#fs4-content-lock{margin:32px 0;text-align:center}' +
      '.fs4-gate{background:linear-gradient(180deg,#f8fbff 0%,#eef4fb 100%);border:2px solid #003478;border-radius:12px;padding:40px 32px;max-width:560px;margin:0 auto}' +
      '.fs4-gate-icon{font-size:48px;margin-bottom:12px}' +
      '.fs4-gate h3{font-size:20px;font-weight:700;color:#003478;margin:0 0 8px}' +
      '.fs4-gate p{font-size:15px;color:#4a5568;margin:0 0 20px;line-height:1.6}' +
      '.fs4-gate-tags{display:flex;flex-wrap:wrap;gap:8px;justify-content:center;margin-bottom:24px}' +
      '.fs4-gate-tag{background:#e6f0ff;color:#003478;padding:4px 12px;border-radius:16px;font-size:13px;font-weight:600}' +
      '.fs4-gate-form{display:grid;grid-template-columns:1fr 1fr;gap:12px;max-width:400px;margin:0 auto}' +
      '.fs4-gate-form input{width:100%;padding:10px 12px;border:1px solid #d0d7e2;border-radius:6px;font-size:14px;box-sizing:border-box}' +
      '.fs4-gate-form input:focus{border-color:#003478;outline:none;box-shadow:0 0 0 3px rgba(0,52,120,0.1)}' +
      '.fs4-gate-submit{grid-column:1/-1;background:#003478;color:#fff;border:none;border-radius:6px;padding:12px;font-size:15px;font-weight:600;cursor:pointer;transition:background 0.15s}' +
      '.fs4-gate-submit:hover{background:#1a5dab}' +
      '.fs4-gate-submit:disabled{opacity:0.5;cursor:not-allowed}' +
      '.fs4-gate-err{grid-column:1/-1;background:#fff5f5;color:#c53030;padding:8px 12px;border-radius:6px;font-size:14px;border:1px solid #fed7d7;text-align:left}' +
      '.fs4-gate-hint{font-size:12px;color:#a0aec0;margin-top:4px;text-align:left}' +
      '@media(max-width:600px){.fs4-gate-form{grid-template-columns:1fr}.fs4-gate{padding:28px 20px}}';
    lockBox.appendChild(style);

    var box = document.createElement('div');
    box.className = 'fs4-gate';
    box.innerHTML =
      '<div class="fs4-gate-icon">\uD83D\uDD12</div>' +
      '<h3>Customer-exclusive content</h3>' +
      '<p>The full guide below is available to verified FordSync4 customers.<br>Enter your order number to unlock.</p>' +
      '<div class="fs4-gate-tags">' +
        '<span class="fs4-gate-tag">Detailed instructions</span>' +
        '<span class="fs4-gate-tag">Wiring diagrams</span>' +
        '<span class="fs4-gate-tag">Hidden features</span>' +
        '<span class="fs4-gate-tag">Technical specs</span>' +
      '</div>' +
      '<div id="fs4-gate-error"></div>' +
      '<div class="fs4-gate-form">' +
        '<div><input type="text" id="fs4-gate-order" placeholder="Order # (e.g., FS4****)" /><div class="fs4-gate-hint">From your confirmation email</div></div>' +
        '<div><input type="text" id="fs4-gate-name" placeholder="Last name on order" /><div class="fs4-gate-hint">The last name on your order</div></div>' +
        '<button class="fs4-gate-submit" id="fs4-gate-btn">\uD83D\uDD13 Unlock Full Guide</button>' +
      '</div>';
    lockBox.appendChild(box);

    // 在标记原地插入:锁框 + 内容容器,然后移除标记
    parent.insertBefore(lockBox, markerNode);
    parent.insertBefore(gated, markerNode);
    parent.removeChild(markerNode);

    function inject(html) {
      gated.innerHTML = html || '';
      gated.style.display = 'block';
      lockBox.style.display = 'none';
    }

    function verify(order, name) {
      return fetch(API_BASE + '/api/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_number: order, name: name, slug: slug })
      }).then(function (res) { return res.json(); });
    }

    // 有存的凭证 → 自动解锁(免重填)
    var creds = getCreds();
    if (creds && creds.order && creds.name) {
      verify(creds.order, creds.name)
        .then(function (d) { if (d && d.ok) inject(d.html); })
        .catch(function () { /* 忽略,显示锁框 */ });
    }

    function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
    function showErr(msg) {
      var errEl = document.getElementById('fs4-gate-error');
      var btn = document.getElementById('fs4-gate-btn');
      if (errEl) errEl.innerHTML = '<div class="fs4-gate-err">' + esc(msg) + '</div>';
      if (btn) { btn.textContent = '\uD83D\uDD13 Unlock Full Guide'; btn.disabled = false; }
    }

    function handleUnlock() {
      var orderEl = document.getElementById('fs4-gate-order');
      var nameEl = document.getElementById('fs4-gate-name');
      var errEl = document.getElementById('fs4-gate-error');
      var btn = document.getElementById('fs4-gate-btn');
      var order = orderEl ? orderEl.value.trim() : '';
      var name = nameEl ? nameEl.value.trim() : '';

      if (!order || !name) { if (errEl) errEl.innerHTML = '<div class="fs4-gate-err">Please enter both order number and last name.</div>'; return; }

      btn.textContent = 'Verifying...'; btn.disabled = true; if (errEl) errEl.innerHTML = '';

      verify(order, name).then(function (d) {
        if (d && d.ok) { setCreds({ order: order, name: name }); inject(d.html); }
        else if (d && d.error === 'rate_limited') { showErr('Too many attempts. Please try again in a few minutes.'); }
        else { showErr("We couldn't match that order. Check your order number and the last name on the order."); }
      }).catch(function () { showErr('Network error. Please try again.'); });
    }

    setTimeout(function () {
      var btn = document.getElementById('fs4-gate-btn');
      if (btn) btn.addEventListener('click', handleUnlock);
      ['fs4-gate-order', 'fs4-gate-name'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.addEventListener('keydown', function (e) { if (e.key === 'Enter') handleUnlock(); });
      });
    }, 0);
  }

  // DOM 就绪后再跑(防止脚本在正文渲染前执行)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();